import React from 'react';
import PropTypes from 'prop-types';
import styles from './Step.module.sass';

function Step(props) {
  const { currentStep, totalSteps, color } = props;
  return (
    <div className={styles.step} style={{ color }}>
      {`${currentStep}/${totalSteps}`}
    </div>
  );
}

Step.propTypes = {
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
  color: PropTypes.string,
};

Step.defaultProps = {
  color: null,
};

export default Step;
